export function areCaseInsensitiveEqual(arg1, arg2) {
  return (
    (arg1 ?? '').toString().toUpperCase() ===
    (arg2 ?? '').toString().toUpperCase()
  );
}
